import { FunctionComponent } from 'react';
import styles from './Button.module.scss';
import CuddlesButton from 'components/UI/V3/Button/Button';

interface ButtonProps {
    label: string;
    disabled?: boolean;
    saving?: boolean;
    onClick?: () => void;
}
export const Button: FunctionComponent<ButtonProps> = props => {
    return (
        <CuddlesButton
            label={props.label}
            noColorOnDisabled
            disabled={props.disabled}
            isLoading={props.saving}
            onClick={props.onClick}
            className={styles.button}
        />
    );
};
